// src/pages/Home.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import rpapts from '../assets/rpapts.png';
import rpabanner from '../assets/rpabanner.jpg';
import './Home.css'; 

// --- ÍCONES ---
const RoadIcon = () => <svg height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 22h16"/><path d="M4 2L2 22"/><path d="M20 2l2 20"/><path d="M12 2v20"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M12 18h.01"/><path d="M12 6h.01"/></svg>;
const CpuIcon = () => <svg height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"/><rect x="9" y="9" width="6" height="6"/><path d="M9 1v3"/><path d="M15 1v3"/><path d="M9 20v3"/><path d="M15 20v3"/><path d="M20 9h3"/><path d="M20 14h3"/><path d="M1 9h3"/><path d="M1 14h3"/></svg>;
const ShieldIcon = () => <svg height="40" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-page"> 
      <title>PTS DEV | Hub de Soluções em IA e Automação</title>
      <meta name="description" content="A PTS DEV é o Hub definitivo de Inteligência Artificial para engenharia, Automação de Processos (RPA) e soluções digitais." />
      
      {/* HERO BANNER PRINCIPAL */}
      <section id="hero-main" className="hero-rpa-banner" style={{ backgroundImage: `url(${rpabanner})`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
        <div className="hero-rpa-overlay"></div>
        <div className="container hero-rpa-content">
          <span className="pts-badge-premium" style={{ marginBottom: '15px', display: 'inline-block' }}>O Hub da Engenharia 4.0</span>
          <h1 className="hero-rpa-title">O Futuro do seu Negócio <br/>Escrito em Código.</h1>
          <p className="hero-rpa-subtitle">
            Ecossistema de soluções em Inteligência Artificial, Automação Corporativa e Identidade Digital.
          </p>
        </div>
      </section>

      {/* VITRINE DE PRODUTOS */}
      <section style={{ padding: '80px 20px', backgroundColor: '#f8fafc', textAlign: 'center' }}>
        <div className="container">
          <h2 className="section-title" style={{ fontSize: '2.5rem', color: '#1e293b', marginBottom: '15px' }}>Nossas Soluções</h2>
          <p className="section-subtitle" style={{ fontSize: '1.2rem', color: '#475569', maxWidth: '800px', margin: '0 auto 50px auto' }}>
            Escolha a tecnologia que vai revolucionar a sua operação hoje.
          </p>
          
          <div className="verticals-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
            
            

            {/* PRODUTO 2: RPA */}
            <div className="vertical-card" style={{ backgroundColor: '#ffffff', padding: '40px 30px', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', borderTop: '4px solid #f59e0b', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ backgroundColor: '#fef3c7', padding: '20px', borderRadius: '50%', marginBottom: '20px' }}>
                <CpuIcon />
              </div>
              <h3 style={{ color: '#0f172a', marginBottom: '15px', fontSize: '1.5rem' }}>Automação RPA</h3>
              <p style={{ color: '#475569', lineHeight: '1.6', marginBottom: '25px', fontSize: '0.95rem' }}>
                Substitua a digitação manual por uma Força de Trabalho Digital. Robôs que operam ERPs, portais e planilhas 24/7 com 100% de precisão para financeiro e RH.
              </p>
              <button onClick={() => navigate('/rpa-e-automacao')} className="pts-btn-launch" style={{ marginTop: 'auto', width: '100%', padding: '15px', backgroundColor: '#f59e0b', color: '#fff' }}>
                Conheça a Solução
              </button>
            </div>

            {/* PRODUTO 3: CERTIFICADO DIGITAL */}
            <div className="vertical-card" style={{ backgroundColor: '#ffffff', padding: '40px 30px', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', borderTop: '4px solid #10b981', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ backgroundColor: '#dcfce7', padding: '20px', borderRadius: '50%', marginBottom: '20px' }}>
                <ShieldIcon />
              </div>
              <h3 style={{ color: '#0f172a', marginBottom: '15px', fontSize: '1.5rem' }}>Certificado Digital</h3>
              <p style={{ color: '#475569', lineHeight: '1.6', marginBottom: '25px', fontSize: '0.95rem' }}>
                Emissão ágil e segura de e-CPF e e-CNPJ. Proteja suas transações e assine documentos eletrônicos com validade jurídica sem sair de casa.
              </p>
              <button onClick={() => navigate('/certificado-digital')} className="pts-btn-primary" style={{ marginTop: 'auto', width: '100%', padding: '15px', backgroundColor: '#10b981', borderColor: '#10b981' }}>
                Emitir Agora
              </button>
            </div>

          </div>
        </div>
      </section>

    </div> 
  );
};

export default Home;